import React from "react";
import lbl from "../../../data/Labels.json";

const FinancePastBalance = ({ balance }) => {
  return (
      <div dir="rtl"  className="white-background-with-border" style={{padding: "10px"}}>
        <div className="">
          <div style={{display: "flex", placeContent: "start", fontSize: "12px", color: "var(--dark-gray)"}}>
            <div style={{width: "200px"}}>
              <p className="title">{lbl.Amount}</p>
              <b>{balance?.amount}</b>
            </div>
            <div style={{width: "200px"}}>
              <p className="title">{"ثبت کننده"}</p>
              <b>{balance?.modified_by}</b>
            </div>
            <div style={{width: "200px"}}>
              <p className="title">{"تایید کننده"}</p>
              <b>{balance?.verified_by}</b>
            </div>
            <div style={{width: "200px"}}>
              <p className="title">{"تاریخ ارزیابی"}</p>
              <b>{balance?.verification_date}</b>
            </div>
          </div>

          <hr style={{
            border: "none",
            background: "#c1c1c1",
            margin: "10px 0",
            height: "1px",
          }}/>

          <pre  style={{color: "var(--dark-gray)"}} className="paragraph">{balance?.remark}</pre>
        </div>
      </div>
  );
};

export default FinancePastBalance;
